import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const teamMembers = [
  {
    name: "Alvin Albert Michael",
    title: "Web Developer",
    imageUrl: "/Alvin.jpg", 
  },
  {
    name: "Rishav Raj",
    title: "Web Developer",
    imageUrl: "/Rishav.jpg",
  },
  {
    name: "Rishabh Raj",
    title: "App Developer",
    imageUrl: "/Rishabh.jpg",
  },
  {
    name: "Sunnat Qayoom",
    title: "App Developer",
    imageUrl: "/Sunnat.jpg",
  },
  {
    name: "Junaid",
    title: "Designer",
    imageUrl: "/Junaid.jpg",
  },
  {
    name: "Ankit Nayak",
    title: "Designer",
    imageUrl: "/Ankit.jpg",
  },
];

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, 
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 2000, 
    fade: true, 
    arrows: true, 
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h2 className="text-4xl font-bold mb-12">Meet the Team</h2>
      <div className="w-full max-w-5xl">
        <Slider {...settings}>
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center text-center p-6 h-96"
            >
              <div className="flex items-center justify-center w-full h-full">
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className="w-80 h-80 rounded-xl mb-6 bg-white object-cover"
                />
              </div>
              <h3 className="text-2xl font-semibold">{member.name}</h3>
              <p className="text-lg">{member.title}</p>
              
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Carousel;
